import $http from '@/resource';
import utils from '@/utils';

const $api = {};

/**
 * 获取附件分类数据
 *
 * @author zyz 2020-7-3 14:34:56
 *
 * @method GET
 *
 * @param {String} type 项目类型1-土地2-厂房
 *
 * @url company/file
 *
 * @return {Promise<void>}
 */
$api.getFileCategory = async (type)=>{
    const url = `company/file?type=${type}`;
    return await $http.get(url);
};

/**
 * 转移附件分类数据并删除附件分类
 *
 * @author zyz 2020-7-6 10:42:01
 *
 * @method DELETE
 *
 * @param {String} id 待删除项的id
 * @param {String} targetId 待转移的目标分类id
 *
 * @url `company/file`
 *
 * @return {Promise<*>}
 */
$api.deleteFileCate = async (id,targetId="")=>{
    const url = `company/file?id=${id}&targetId=${targetId}`;
    return await $http.delete(url);
};

/**
 * 保存附件分类结果
 *
 * @author zyz 2020-7-6 11:56:41
 *
 * @method POST
 *
 * @param {Array} data 待保存的数据
 *
 * @url `company/file`
 *
 * @return {Promise<*>}
 */
$api.saveFileCate = async (data)=>{
    const url = `company/file`;
    return await $http.post(url,data);
};

export default $api;


// WEBPACK FOOTER //
// ./src/service/company/fileConfig.js